import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'app/store';

const selectAlertsState = (state: RootState) => state.alerts;

export const selectAlertsMetadata = createSelector(
  [selectAlertsState],
  ({ page, pageSize, total, totalUnreadCount }) => {
    return {
      page,
      pageSize,
      total,
      totalUnreadCount,
    };
  },
);

export const selectAlerts = createSelector(
  [selectAlertsState],
  (alertsState) => alertsState.content ?? [],
);

export const selectUnreadAlertsCount = createSelector(
  [selectAlertsMetadata],
  (alertsMetadata) => alertsMetadata.totalUnreadCount || 0,
);
